import axiosInstance from './axios';

export interface Vehicle {
    id: string;
    placa: string;
    tipo: 'AUTO' | 'MOTO' | 'CAMIONETA' | 'CAMION' | 'BICICLETA';
    marca?: string;
    modelo?: string;
    color?: string;
    propietario?: string;
    telefono?: string;
    status: 'DENTRO' | 'FUERA';
    horaEntrada?: string;
}

export interface CreateVehicleData {
    placa: string;
    tipo: string;
    marca?: string;
    modelo?: string;
    color?: string;
    propietario?: string;
    telefono?: string;
}

export const getVehicles = async (): Promise<Vehicle[]> => {
    const response = await axiosInstance.get<Vehicle[]>('/vehicles');
    return response.data;
};

export const createVehicle = async (data: CreateVehicleData): Promise<Vehicle> => {
    const response = await axiosInstance.post<Vehicle>('/vehicles', data);
    return response.data;
};

export const deleteVehicle = async (id: string): Promise<void> => {
    await axiosInstance.delete(`/vehicles/${id}`);
};

export const updateVehicle = async (id: string, data: Partial<CreateVehicleData>): Promise<Vehicle> => {
    const response = await axiosInstance.patch<Vehicle>(`/vehicles/${id}`, data);
    return response.data;
};

export interface VehicleWithContract extends Vehicle {
    hasActiveContract: boolean;
    contractStatus: 'ACTIVO' | 'VENCIDO' | 'CANCELADO' | 'NINGUNO';
    activeContract: any | null;
    relevantContract: any | null;
}

export const getVehicleByPlaca = async (placa: string): Promise<VehicleWithContract> => {
    const response = await axiosInstance.get<VehicleWithContract>(`/vehicles/placa/${placa}`);
    return response.data;
};
